<!-- Dialogs -->
<app-deprecated-confirmation-dialog
    #deleteConfirmationDialog
    description="forms.payroll-edit.removeThisEmployeeFromThePayrollRun"
    label="delete"
    [negative]="true"
>
</app-deprecated-confirmation-dialog>

<!-- bonus -->
<app-deprecated-modal-form
    (save)="onSaveBonusPayItems(formEditBonusPayItems.paystub)"
    (cancel)="formEditBonusPayItems.paystub?.revertAdditionalPayItems()"
    secondaryActionText="forms.payroll-edit.learnMoreAboutBonusTypes"
    (secondaryAction)="openHelpArticle()"
    #editBonusPayItems
    headerText="forms.payroll-edit.bonus"
    [form]="formEditBonusPayItems"
>
    <app-form-edit-bonus-pay-items #formEditBonusPayItems></app-form-edit-bonus-pay-items>
</app-deprecated-modal-form>

<!-- Other income w/insurable hours capture -->
<ui-dialog
    #editInsurableHoursCapture
    [open]="displayInsurableHoursOtherIncomeModal"
    formDialog
    [form]="editInsurableHoursCaptureForm.form"
    size="medium"
    [header]="'forms.payroll-edit.otherIncomeForEmployeeName' | translate: { employeeName }"
    [primaryButtonLabel]="
        editInsurableHoursCaptureForm.hasActiveIncomeTypes
            ? ('forms.payroll-edit.saveTotal'
              | translate
                  : { total: editInsurableHoursCaptureForm.insurableHoursAdditionalPayItemsTotal | i18nNum: '$' })
            : 'forms.payroll-edit.setUpIncomeTypes'
    "
    [stickyButtons]="true"
    [stickyHeader]="true"
    [applyHeaderPadding]="true"
    (primaryButtonPressed)="
        editInsurableHoursCaptureForm.hasActiveIncomeTypes
            ? onSaveInsurableHoursCaptureItems(
                  editInsurableHoursCaptureForm.insurableHourlyPayItems,
                  editInsurableHoursCaptureForm.insurableDollarPayItems,
                  editInsurableHoursCaptureForm
              )
            : router.navigate(['/', 'payroll', 'additional-incomes'])
    "
    (secondaryButtonPressed)="
        currentSelectedPaystub = null;
        editInsurableHoursCaptureForm.insurableHoursAdditionalPayItemsTotal = '0.00';
        allowRecalculation = true;
        displayInsurableHoursErrorString = false;
        insurableHoursErrorString = '';
        shouldOtherIncomeInsurableHoursBeDisplayed(false)
    "
    (closing)="
        currentSelectedPaystub = null;
        editInsurableHoursCaptureForm.insurableHoursAdditionalPayItemsTotal = '0.00';
        allowRecalculation = true;
        displayInsurableHoursErrorString = false;
        insurableHoursErrorString = '';
        shouldOtherIncomeInsurableHoursBeDisplayed(false)
    "
>
    <app-payroll-insurable-hours-form
        #editInsurableHoursCaptureForm
        [paystub]="currentSelectedPaystub!"
        [payroll]="payroll"
        [displayInsurableHoursErrorString]="displayInsurableHoursErrorString"
        [allowRecalculation]="allowRecalculation"
        [insurableHoursErrorString]="insurableHoursErrorString"
        [insurableHoursAdditionalPayItemsTotal]="insurableHoursAdditionalPayItemsTotal"
    >
    </app-payroll-insurable-hours-form>
</ui-dialog>

<!-- Additional pay items tax warning -->
<ui-dialog
    [header]="
        (!!additionalPayItemsTaxWarningItemName
            ? 'forms.payroll-edit.exceedsRegularPayAmount'
            : 'forms.payroll-edit.additionalPayItemExceedsRegularPayAmount'
        ) | translate: { name: additionalPayItemsTaxWarningItemName }
    "
    [open]="isShowingAdditionalPayItemsTaxWarning"
    primaryButtonLabel="continue"
    (primaryButtonPressed)="isShowingAdditionalPayItemsTaxWarning = false"
>
    <p>{{ 'forms.payroll-edit.beforeRunningPayrollReviewTaxCalculationToEnsureAccuracyContactS' | translate }}</p>
</ui-dialog>

<form *ngIf="showForm" #form="ngForm">
    <table class="ui fixed table">
        <thead>
            <tr>
                <th>
                    {{ 'forms.payroll-edit.employee' | translate }}
                    <span (click)="onSort()">
                        <span class="icon">
                            <mat-icon svgIcon="arrowUp" *ngIf="sortDirection === 'ASC'"></mat-icon>
                            <mat-icon svgIcon="arrowDown" *ngIf="sortDirection === 'DESC'"></mat-icon>
                        </span>
                    </span>
                </th>
                <th>{{ 'forms.payroll-edit.compensation' | translate }}</th>
                <th>{{ 'forms.payroll-edit.extraPay' | translate }}</th>
                <th>{{ 'forms.payroll-edit.grossPay' | translate }}</th>
                <th *ngIf="!payroll.recurring" style="width: 60px"></th>
            </tr>
        </thead>
        <ng-container *ngFor="let paystub of paystubService.payStubs | async; let index = index">
            <tbody>
                <tr>
                    <td class="payroll-employee-name">
                        <div class="small left aligned title">
                            {{ paystub.employee?.firstName }} {{ paystub.employee?.lastName }}
                            <ui-badge *ngIf="paystub.employee?.isTerminated" type="danger">{{
                                'forms.payroll-edit.terminated' | translate
                            }}</ui-badge>
                            <ui-badge *ngIf="!paystub.isDirectDeposit" type="default">{{
                                'forms.payroll-edit.chq' | translate
                            }}</ui-badge>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <ng-container *ngIf="paystub.salaryPayItems?.length">
                            <div
                                *ngFor="let salaryPayItem of paystub.orderedSalaryPayItems | filter: 'periodic' : true"
                                class="small left aligned thin title payroll-employee-compensation"
                            >
                                <span>
                                    {{
                                        'forms.payroll-edit.ratePerUnit'
                                            | translate
                                                : {
                                                      rate: salaryPayItem?.compensationRate | i18nNum: '$',
                                                      unit: salaryPayItem?.compensationUnit | lowercase,
                                                  }
                                    }}
                                    <span *ngIf="salaryPayItem.name?.length">
                                        -
                                        {{
                                            PayrollSalaryItemNamesDisplayOptions[salaryPayItem.name] ||
                                                salaryPayItem.name | translate
                                        }}
                                    </span>
                                </span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="paystub.hourlyPayItems?.length">
                            <div
                                *ngFor="let hourlyPayItem of paystub.hourlyPayItems"
                                class="small left aligned thin title payroll-employee-compensation payroll-hourly-compensation {{
                                    hourlyPayItem.canAddOvertime && !hasOvertime(paystub, hourlyPayItem)
                                        ? 'payroll-hourly-primary-compensation'
                                        : ''
                                }}"
                            >
                                <!-- Only show a description if the item has been persisted to the database. Overtime items can be created in this form -->
                                <span *ngIf="hourlyPayItem.id">
                                    {{
                                        'forms.payroll-edit.ratePerUnit'
                                            | translate
                                                : {
                                                      rate: hourlyPayItem?.compensationRate | i18nNum: '$',
                                                      unit: hourlyPayItem?.compensationUnit | lowercase,
                                                  }
                                    }}
                                    <span *ngIf="hourlyPayItem.name?.length">
                                        -
                                        {{
                                            hourlyPayItem.multiplier === OVERTIME_MULTIPLIER
                                                ? ('forms.payroll-edit.overtime' | translate)
                                                : (PayrollSalaryItemNamesDisplayOptions[hourlyPayItem.name] ||
                                                      hourlyPayItem.name | translate)
                                        }}
                                    </span>
                                </span>
                                <ng-container *ngIf="hourlyPayItem.startsOrEndsInPayPeriod">
                                    <span
                                        *ngIf="
                                            hourlyPayItem.compensationEffectiveFrom &&
                                            !hourlyPayItem.compensationEffectiveTo
                                        "
                                        class="hourly-effective-message"
                                        >{{
                                            'forms.payroll-edit.thisRateStartedFromDate'
                                                | translate: { date: hourlyPayItem.compensationEffectiveFrom | date }
                                        }}
                                    </span>
                                    <span *ngIf="hourlyPayItem.compensationEffectiveTo" class="hourly-effective-message"
                                        >{{
                                            'forms.payroll-edit.thisRateEndedOnDate'
                                                | translate: { date: hourlyPayItem.compensationEffectiveTo | date }
                                        }}
                                    </span>
                                </ng-container>
                            </div>
                        </ng-container>
                        <mat-checkbox
                            [matTooltip]="'forms.payroll-edit.thisPayrollIsLate' | translate"
                            [matTooltipDisabled]="!payroll.late"
                            matTooltipPosition="above"
                            [(ngModel)]="paystub.isDirectDeposit"
                            (ngModelChange)="savePaystub(paystub)"
                            [name]="paystub.id + '-isDirectDeposit'"
                            tabindex="-1"
                            [disabled]="payroll.late || !paystub.canDirectDeposit"
                            >{{ 'forms.payroll-edit.directDeposit' | translate }}</mat-checkbox
                        >
                        <!--
                            Disabled mat checkboxes make a form invalid.
                            In the case that the payroll run is empty we still want the form to be valid (so app steps can proceed forward
                        -->
                        <input
                            *ngIf="payroll.late"
                            type="hidden"
                            [ngModel]="true"
                            [name]="'validateThisCheckbox' + paystub.id"
                        />
                    </td>
                    <td>
                        <ng-container *ngIf="!payroll.recurring">
                            <div class="small title">{{ 'forms.payroll-edit.offcycle' | translate }}</div>
                        </ng-container>

                        <!-- Salary -->
                        <ng-container *ngIf="paystub.salaryPayItems?.length">
                            <mat-form-field
                                *ngFor="
                                    let salaryPayItem of paystub.orderedSalaryPayItems | filter: 'periodic' : true;
                                    let index = index
                                "
                            >
                                <mat-label
                                    >{{ 'forms.payroll-edit.salary' | translate
                                    }}<ui-badge type="warning" *ngIf="salaryPayItem.isProrated">{{
                                        'forms.payroll-edit.prorated' | translate
                                    }}</ui-badge></mat-label
                                >
                                <input
                                    matInput
                                    [textMask]="{ mask: currency }"
                                    placeholder="{{ 'forms.payroll-edit.salary' | translate }}"
                                    [name]="paystub.id + '-salaryPayItem-' + index"
                                    [ngModel]="getFormattedAmount(salaryPayItem, 0)"
                                    (ngModelChange)="setFormattedAmount(salaryPayItem, $event)"
                                />
                            </mat-form-field>
                        </ng-container>

                        <!-- Hourly -->
                        <ng-container *ngIf="paystub.hourlyPayItems?.length">
                            <div *ngFor="let hourlyPayItem of paystub.hourlyPayItems; let index = index">
                                <mat-form-field>
                                    <mat-label
                                        >{{ 'forms.payroll-edit.hourly' | translate
                                        }}{{
                                            hourlyPayItem.multiplier === OVERTIME_MULTIPLIER
                                                ? ('forms.payroll-edit.overtimeParentheses' | translate)
                                                : ''
                                        }}</mat-label
                                    >
                                    <input
                                        matInput
                                        placeholder="{{ 'forms.payroll-edit.hours' | translate }}"
                                        [name]="paystub.id + '-hourlyPayItem-' + index"
                                        [disabled]="hourlyPayItem.employeeHoursExists"
                                        [ngModel]="getFormattedHours(hourlyPayItem, 2)"
                                        (ngModelChange)="setFormattedHours(hourlyPayItem, $event)"
                                    />
                                    <span matSuffix *ngIf="hourlyPayItem.multiplier === OVERTIME_MULTIPLIER"
                                        >&#64; {{ OVERTIME_MULTIPLIER | i18nNum: 'no$' }}x</span
                                    >
                                    <span matSuffix *ngIf="hourlyPayItem.multiplier !== OVERTIME_MULTIPLIER"
                                        >&#64; {{ hourlyPayItem.rate | i18nNum: '$' }}</span
                                    >
                                </mat-form-field>
                                <a
                                    *ngIf="!hasOvertime(paystub, hourlyPayItem) && hourlyPayItem.canAddOvertime"
                                    class="pay-item-link overtime"
                                    (click)="addOvertime(paystub, hourlyPayItem)"
                                    >+ {{ 'forms.payroll-edit.overtime' | translate }}</a
                                >
                            </div>
                        </ng-container>
                    </td>
                    <td>
                        <ng-container
                            *ngFor="let additionalPayItem of paystub.orderedAdditionalPayItems(); let index = index"
                        >
                            <ng-container [ngSwitch]="additionalPayItem.name">
                                <!-- Commission -->
                                <ng-container *ngSwitchCase="'commission'">
                                    <mat-form-field>
                                        <mat-label>{{ 'forms.payroll-edit.commission' | translate }}</mat-label>
                                        <input
                                            matInput
                                            [textMask]="{ mask: currency }"
                                            [name]="paystub.id + '-commission-' + index"
                                            [ngModel]="getFormattedAmount(additionalPayItem)"
                                            (ngModelChange)="setFormattedAmount(additionalPayItem, $event)"
                                            placeholder="{{ 'forms.payroll-edit.commission' | translate }}"
                                        />
                                        <mat-icon
                                            *ngIf="shouldWarnForAdditionalPayItem(additionalPayItem)"
                                            matSuffix
                                            class="warning"
                                            svgIcon="warning"
                                        ></mat-icon>
                                    </mat-form-field>
                                </ng-container>

                                <!-- Vacation Pay -->
                                <ng-container *ngSwitchCase="'vacation pay'">
                                    <mat-form-field>
                                        <mat-label>{{ 'forms.payroll-edit.vacationPay' | translate }}</mat-label>
                                        <input
                                            matInput
                                            type="text"
                                            [textMask]="{ mask: currency }"
                                            name="{{ paystub.id }}-vacation-pay-{{ index }}"
                                            [ngModel]="getFormattedAmount(paystub.vacationPayItem)"
                                            (ngModelChange)="setFormattedAmount(additionalPayItem, $event)"
                                            placeholder="{{ 'forms.payroll-edit.vacationPay' | translate }}"
                                        />
                                        <mat-icon
                                            *ngIf="shouldWarnForAdditionalPayItem(additionalPayItem)"
                                            matSuffix
                                            class="warning"
                                            svgIcon="warning"
                                        ></mat-icon>
                                    </mat-form-field>
                                </ng-container>
                            </ng-container>
                        </ng-container>

                        <!-- Bonus Pay -->
                        <ng-container *ngIf="paystub.hasBonusPayItems">
                            <mat-form-field>
                                <mat-label>{{ 'forms.payroll-edit.bonus' | translate }}</mat-label>
                                <input
                                    matInput
                                    [textMask]="{ mask: currency }"
                                    #bonusPayInput
                                    (focus)="
                                        bonusPayInput.blur();
                                        formEditBonusPayItems.paystub = paystub;
                                        editBonusPayItems.show()
                                    "
                                    type="text"
                                    [name]="'bonusPay' + paystub.id"
                                    [ngModel]="getFormattedAmount(paystub.bonusPayItemSum)"
                                />
                                <mat-icon
                                    matSuffix
                                    svgIcon="warning"
                                    class="warning"
                                    *ngIf="bonusTaxWarning && paystub.isBonusMoreThanRegularPay"
                                ></mat-icon>
                            </mat-form-field>
                        </ng-container>

                        <!-- Other -->
                        <ng-container *ngIf="paystub.hasNonRequiredAdditionalPayItems">
                            <mat-form-field class="other-income-input-wrapper">
                                <mat-label>{{ 'forms.payroll-edit.otherIncome' | translate }}</mat-label>
                                <input
                                    class="other-income-input"
                                    matInput
                                    [textMask]="{ mask: currency }"
                                    #otherPayInput
                                    (focus)="
                                        otherPayInput.blur();
                                        currentSelectedPaystub = paystub;
                                        shouldOtherIncomeInsurableHoursBeDisplayed(true)
                                    "
                                    type="text"
                                    [name]="'other' + paystub.id"
                                    [ngModel]="paystub.nonRequiredAdditionalPayItemSum | i18nNum: '$'"
                                />
                            </mat-form-field>
                        </ng-container>
                        <a
                            *ngIf="!paystub.hasNonRequiredAdditionalPayItems"
                            class="pay-item-link other"
                            (click)="currentSelectedPaystub = paystub; shouldOtherIncomeInsurableHoursBeDisplayed(true)"
                            >+ {{ 'forms.payroll-edit.otherIncome' | translate }}</a
                        >
                        <a
                            *ngIf="!paystub.hasBonusPayItems"
                            class="pay-item-link bonus"
                            (click)="formEditBonusPayItems.paystub = paystub; editBonusPayItems.show()"
                            >+ {{ 'forms.payroll-edit.bonus' | translate }}</a
                        >
                        <a
                            *ngIf="!hasCommission(paystub)"
                            class="pay-item-link commission"
                            (click)="addAdditionalPayItem(paystub, 'commission')"
                            >+ {{ 'forms.payroll-edit.commission' | translate }}</a
                        >
                    </td>
                    <td>
                        <div class="title">{{ paystub.grossPay | i18nNum: '$' }}</div>

                        <!-- Reimbursement -->
                        <mat-form-field *ngIf="paystub.reimbursementItem">
                            <mat-label>{{ 'forms.payroll-edit.reimbursement' | translate }}</mat-label>
                            <input
                                matInput
                                type="text"
                                [textMask]="{ mask: currency }"
                                name="{{ paystub.id }}-reimbursement"
                                [ngModel]="getFormattedAmount(paystub.reimbursementItem)"
                                (ngModelChange)="setFormattedAmount(paystub.reimbursementItem, $event)"
                                placeholder="{{ 'forms.payroll-edit.reimbursement' | translate }}"
                            />
                        </mat-form-field>

                        <a
                            *ngIf="!paystub.reimbursementItem"
                            class="pay-item-link reimbursement"
                            (click)="addReimbursement(paystub)"
                            >+ {{ 'forms.payroll-edit.reimbursement' | translate }}</a
                        >
                    </td>
                    <td class="right aligned collapsing" *ngIf="!payroll.recurring">
                        <app-context-menu>
                            <app-context-item label="delete" (click)="deletePaystub(paystub)"></app-context-item>
                        </app-context-menu>
                    </td>
                </tr>
            </tbody>
        </ng-container>
    </table>
</form>
